













import Vue from 'vue'

export default Vue.extend({
  name: "UiSkeleton",
  props: {
    type: String // "h1" | "p"
  }
})
